class ProductFormVariants extends HTMLElement {
  constructor() {
    super();

    const elements = {
      form: this.closest("form"),
      select: this.querySelectorAll("select")
    };

    elements.select.forEach((element) => {
      element.addEventListener("change", (event) => {
        const variant = get_variant();

        document.dispatchEvent(new CustomEvent("productformvariants:change", {
          detail: {
            variant: variant
          }
        }));

        Theme.URLParams.set("variant", variant.id);

        elements.form.querySelector("[name=id]").value = variant.id;
      });
    });

    function get_variant() {
      const variant_title = get_variant_title(elements.select);
      const variant = get_variant_by_title(variant_title);

      return variant;
    }

    function get_variant_title(form_elements) {
      return Array.from(form_elements)
        .map(element => element.value)
        .join(" / ")
        .trim();
    }

    function get_variant_by_title(title) {
      let selected_variant = null;

      Theme.Liquid.product.variants.forEach((variant) => {
        if (title == variant.title) {
          selected_variant = variant;
        }
      });

      return selected_variant;
    }
  }
}

customElements.define("product-form-variants", ProductFormVariants)